import PersonVectorIcon from './PersonVectorIcon';

export default PersonVectorIcon;
